const initialState = {
    collection: [],
    invalidBarcode: false,
    loading: false,
    orderableStatus: [],
    duplicateProductInfo: {},
    isProductLimitExceeded: false,
};

const SET_COLLECTION = 'SET_COLLECTION';
const SET_ORDERABLE_STATUS = 'SET_ORDERABLE_STATUS';
const SET_DUPLICATE_PRODUCT_INFO = 'SET_DUPLICATE_PRODUCT_INFO';
const SET_IS_PRODUCT_LIMIT_EXCEEDED = 'SET_IS_PRODUCT_LIMIT_EXCEEDED';

export const setCollection = (data) => ({
    type: SET_COLLECTION,
    payload: data,
});
export const setOrderableStatus = (data) => ({ type: SET_ORDERABLE_STATUS, payload: data });
export const setDuplicateProductInfo = (data) => ({
    type: SET_DUPLICATE_PRODUCT_INFO,
    payload: data,
});
export const setIsProductLimitExceeded = (data) => ({
    type: SET_IS_PRODUCT_LIMIT_EXCEEDED,
    payload: data,
});

export default (state = initialState, action) => {
    switch (action.type) {
        case SET_COLLECTION:
            return { ...state, collection: action.payload };
        case SET_ORDERABLE_STATUS:
            return { ...state, orderableStatus: action.payload };
        case SET_DUPLICATE_PRODUCT_INFO:
            return { ...state, duplicateProductInfo: action.payload };
        case SET_IS_PRODUCT_LIMIT_EXCEEDED:
            return { ...state, isProductLimitExceeded: action.payload };
        default:
            return state;
    }
};
